import { useEffect } from 'react';
import { Images } from 'assets/images';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { SelectWrapper } from 'admin/layout/styled';
import {
  AddButton,
  ButtonsWrapper,
  ComponentTopBlock,
  InfoInput,
  Option,
  OptionsOfTemplates,
  SampleImage,
  SampleSpan,
  SelectFromTemplates,
  SendOfferButton,
  StatusSelect,
  TitleAndAddButton,
  TitleDescriptionAndStatusWrapper,
  TitleOfPage,
} from 'admin/components/Offer/styled';

export const OfferTopBlock = ({
  openCreateModal,
  setOfferData,
  setTableOptions,
  tableOptions,
}) => {
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  const openTemplates = () => {
    setIsOpen((prev) => !prev);
  };

  const addTemplate = (element) => {
    setTableOptions(tableOptions.filter((g) => g.id !== element.id));
    setOfferData((prev) => [...prev, element]);
  };

  useEffect(() => {
    if (tableOptions.length < 1) {
      setIsOpen(false);
    }
  }, [tableOptions]);

  return (
    <ComponentTopBlock>
      <TitleAndAddButton>
        <TitleOfPage>Offers</TitleOfPage>
        <ButtonsWrapper>
          <SelectFromTemplates ref={ref}>
            <SampleSpan onClick={openTemplates}> Add From Template </SampleSpan>
            <SampleImage src={Images.rowDown} onClick={openTemplates} />
            {isOpen && (
              <OptionsOfTemplates>
                {tableOptions.map((element) => (
                  <Option key={element.id}>
                    <SampleSpan>{element.title} </SampleSpan>
                    <SampleSpan onClick={() => addTemplate(element)}> + </SampleSpan>
                  </Option>
                ))}
              </OptionsOfTemplates>
            )}
          </SelectFromTemplates>
          <AddButton onClick={openCreateModal}>+ Add</AddButton>
          <SendOfferButton>Send</SendOfferButton>
        </ButtonsWrapper>
      </TitleAndAddButton>
      <TitleDescriptionAndStatusWrapper>
        <InfoInput placeholder="Title" />
        <InfoInput placeholder="Description" />
        <SelectWrapper isStatus>
          <StatusSelect>
            <option>Status</option>
            <option>Select from the templates</option>
            <option>Select from the templates</option>
            <option>Select from the templates</option>
            <option>Select from the templates</option>
          </StatusSelect>
        </SelectWrapper>
      </TitleDescriptionAndStatusWrapper>
    </ComponentTopBlock>
  );
};
